/**
 * 表格混入
 * 在导入/导出有部分差别
 */
import XGrid from '@/components/grid/XGrid'
import {mapGetters} from 'vuex'
import {CONSTANT as constant} from '@/services/constant'
import api from '@/services/api'
import {loadBaseCodeData} from '@/services/baseCodeSource'
import {dataApi} from '@/services/exportSource'

const GridMixin = {
	name: 'xGridList',
	// authorize: {
	// 	addRow: "ADD",
	// 	updateRow: 'UPDATE',
	// 	delRow: 'DELETE',
	// 	importMethod: 'IMPORT',
	// 	exportMethod: 'EXPORT',
	// },
	components: {
		XGrid
	},
	/**
	 * 将当前用户加载到页面中
	 */
	computed: {
		...mapGetters('account', ['user'])
	},
	data() {
		const vm = this
		return {
			params: this.$route.query,
			api,
			constant,
			importUrl: '',
			exportUrl: '',
			exportParams: null,
			popConfig: {},
			clickCheck: true,//点击选中行
			editRowId: 0,//编辑单据主键
			// loading: false,
			editModalVisible: false,
			importConfig: {
				remote: true,
				importMethod: function ({file}) {
					vm.importMethod({
						file
					})
				},
				types: ['xls'],
				modes: ['insert']
			},
			exportConfig: {
				remote: true,
				exportMethod: function ({options}) {
					console.log({options})
					// {file}
					vm.exportMethod({
						options
					})
				},
				types: ['xlsx'],
				modes: ['current', 'selected', 'all']
			}
		}
	},
	methods: {
		/**
		 * 获取行的数据 通过参数可以调整复选或单选 不填会从列中拉取 拉取不成功则提示无选中类型并且返回复选值
		 * @param type
		 * @return {boolean}
		 */
		chooseOneRowReady(type = '') {
			if (!type) {
				type = this.$refs['grid'].$refs['xGrid'].columns[0].type
			}
			let rows = []
			if (type === 'checkbox') {
				rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords()
			} else if (type === 'radio') {
				if (this.$refs['grid'].$refs['xGrid'].getRadioRecord()) {
					rows = [this.$refs['grid'].$refs['xGrid'].getRadioRecord()]
				} else {
					rows = []
				}
			} else {
				console.info('表格无选中类型')
				rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords()
			}

			if (rows.length < 1) {
				this.$message.error('请至少选择一条数据')
				return false
			}
			return true
		},
		/**
		 * 打开加载/关闭加载
		 * @param status
		 */
		loading(status) {
			this.$refs['grid'].loading = !!status
		},

		/**
		 * 表格内弹出层  多选给子组件提供rows及id数组
		 * @param row
		 * @param type
		 * @param many
		 */
		openPop(row, type, many) {
			if (many) {
				this.popConfig[type].id = row.map(v => {
					return v[this.rowId]
				})
				this.popConfig[type].row = row
				this.popConfig[type].show = true
			} else {
				this.popConfig[type].id = row[this.rowId]
				this.popConfig[type].row = row
				this.popConfig[type].show = true
			}
		},
		/**
		 * 关闭弹出层
		 * @param type
		 */
		closePop(type) {
			this.popConfig[type].id = -1
			this.popConfig[type].row = {}
			this.popConfig[type].show = false
		},
		/**
		 * 关闭所有弹出层并刷新
		 */
		closePopAndRefresh() {
			for (let item in this.popConfig) {
				this.popConfig[item].id = -1
				this.popConfig[item].row = {}
				this.popConfig[item].show = false
			}
			this.refresh()
		},

		/**
		 * 工具栏的弹出层处理（针对单条数据 多条单独开发）
		 * @param type
		 * @param many 是否是多条
		 * @param other 自定义判断
		 */
		chooseOpenPop(type, many, other) {
			let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords()
			if (!many) {
				if (row.length !== 1) {
					this.$message.error('请选择一条数据')
					return
				}
				if (typeof other === 'function') {
					other(row[0], type)
				} else {
					this.openPop(row[0], type)
				}
			} else {
				if (row.length < 1) {
					this.$message.error('请至少选择一条数据')
					return
				}
				if (typeof other === 'function') {
					other(row, type, many)
				} else {
					this.openPop(row, type, true)
				}
			}
		},
		// 单选打开弹出层
		radioOpenPop(type, other) {
			let row = this.$refs['grid'].$refs['xGrid'].getRadioRecord()
			if (!row) {
				this.$message.error('请选择一条数据')
				return
			}
			if (typeof other === 'function') {
				other(row, type)
			} else {
				this.popConfig[type].id = row[this.rowId]
				this.popConfig[type].row = row
				this.popConfig[type].show = true
			}
		},
		/**
		 * 获取行的数据 通过参数可以调整复选或单选 不填会从列中拉取 拉取不成功则提示无选中类型并且返回复选值
		 * @param type checkbox/radio
		 * @return {[]|RowInfo[]|any[]}
		 */
		getRows(type = '') {
			if (!type) {
				type = this.$refs['grid'].$refs['xGrid'].columns[0].type
			}
			if (type === 'checkbox') {
				return this.$refs['grid'].$refs['xGrid'].getCheckboxRecords()
			} else if (type === 'radio') {
				if (this.$refs['grid'].$refs['xGrid'].getRadioRecord()) {
					return [this.$refs['grid'].$refs['xGrid'].getRadioRecord()]
				} else {
					return []
				}
			} else {
				console.info('表格无选中类型')
				return this.$refs['grid'].$refs['xGrid'].getCheckboxRecords()
			}
		},
		/**
		 * 表格方法：选中一行  自动遍历表格中所有的列并找出复选或单选类型 如果没有则提示无选择栏
		 * @param row 行数据
		 * @param column 列的信息
		 */
		chooseRow({row, column}) {
			if (this.clickCheck && column.type !== 'checkbox' && column.type !== 'radio') {
				let checkIndex = this.$refs['grid'].$refs['xGrid'].columns.findIndex(item => {
					return item.type === 'checkbox'
				})
				let radioIndex = this.$refs['grid'].$refs['xGrid'].columns.findIndex(item => {
					return item.type === 'radio'
				})
				if (checkIndex > -1) {
					this.$refs['grid'].$refs['xGrid'].toggleCheckboxRow(row).then(() => {
					})
				} else if (radioIndex > -1) {
					this.$refs['grid'].$refs['xGrid'].setRadioRow(row).then(() => {
					})
				} else {
					console.warn('当前表格无选择栏')
				}
			}
		},
		/**
		 * 新增 调用新增表单
		 */
		addRow() {
			this.openEdit(0)
		},
		/**
		 * 编辑 传入某条数据通过主键查询到对应的详情数据
		 * @param row
		 */
		editRow(row) {
			this.openEdit(row[this.rowId])
		},
		/**
		 * 编辑 传入某条数据通过主键查询到对应的详情数据
		 * @param row
		 */
		updateRow({row}) {
			this.editRow(row)
		},
		/**
		 * 双击编辑 传入某条数据通过主键查询到对应的详情数据
		 * @param row
		 */
		cellDbClick({row}) {
			this.editRow(row)
		},
		/**
		 * 打开详情的model
		 * @param keyId
		 */
		openEdit(keyId) {
			this.editRowId = keyId
			this.editModalVisible = true
		},
		/**
		 * 关闭详情的model refresh
		 * @param refresh 是否刷新列表
		 */
		closeEdit(refresh = false) {
			this.editRowId = -1
			this.editModalVisible = false
			if (refresh === true) {
				this.refresh()
			}
		},
		/**
		 * 刷新表格
		 */
		refresh() {
			this.$refs.grid.refresh()
		},
		/**
		 * 执行grid的删除方法 会自动判断表格是单选还是多选并删除选中项
		 */
		delRow(tips) {
			this.$refs.grid.delData(tips)
		},
		importMethod({file}) {
			// 处理表单
			const formBody = new FormData()
			formBody.append('file', file)
			dataApi.importFile(this.importUrl || (this.url + '/import'), file).then(() => {
				this.$message.success('导入成功')
				this.refresh()
			}).catch(e => {
				this.$message.error('导入失败，请检查数据是否正确')
				console.error(e)
			})
			// // 上传文件
			// return XEAjax.post('https://api.xuliangzhan.com:10443/api/pub/import', formBody).then(data => {
			// 	this.$message.success(`成功导入 ${data.result.insertRows} 条记录！`)
			//
			// 	// 导入完成，刷新表格
			// 	this.refresh()
			// }).catch(() => {
			// 	this.$message.error('导入失败，请检查数据是否正确！')
			// })
		},
		/**
		 * 导出的方法
		 * @param options
		 * @return {Promise<void>}
		 */
		async exportMethod({options}) {
			this.loading(true)
			const proxyInfo = this.$refs['grid'].$refs['xGrid'].getProxyInfo()
			let ids
			if (options.mode === 'selected') {
				ids = options.data.map(item => item[this.rowId])
			} else if (options.mode === 'current') {
				ids = options.data.map(item => item[this.rowId])
				options.mode = 'selected'
			}

			// 传给服务端的参数
			const body = {
				filename: options.filename,
				sheetName: options.sheetName,
				containHeader: options.isHeader,
				original: options.original,
				mode: options.mode,
				pager: {
					page: proxyInfo.pager.currentPage,
					limit: proxyInfo.pager.pageSize
				},
				ids,
				fields: options.columns.map(column => {
					return {
						field: column.property,
						title: column.title
					}
				})
			}
			let url = this.exportUrl || this.url + '/exportExcel?'
			const params = JSON.parse(localStorage.getItem('queryParams'))
			for (let item in params) {
				if (params[item]) {
					url += `${item}=${params[item]}&`
				}
			}

			if (this.exportParams) { // 有自定义导出参数
				for (let key in this.exportParams) {
					if (this.exportParams[key] !== null && this.exportParams[key] !== undefined) {
						url += `${key}=${this.exportParams[key]}&`
					}
				}
			}

			console.log(url)
			// 开始服务端导出
			if (options.planMold) {
				await dataApi.exportFile(url + '&planMold=' + options.planMold + '&createType=' + options.createType, body).then(blob => {
					// if(body.mode== "all")
						this.$message.success('正在导出，请在下载中心下载')
						// this.$message.success('导出成功，正在下载')
						let downloadElement = document.createElement('a')
						let href = window.URL.createObjectURL(blob.data) //创建下载的链接
						downloadElement.href = href
						// downloadElement.download = options.filename + '.' + options.type //下载后文件名
						// document.body.appendChild(downloadElement)
						// downloadElement.click() //点击下载
						// document.body.removeChild(downloadElement) //下载完成移除元素
						// window.URL.revokeObjectURL(href) //释放掉blob对象
				}).catch(e => {
					console.error('导出失败:' + e)
					this.$message.error('导出失败')
				})
			} else if (options.planId) {
				await dataApi.exportFile(url + '&planId=' + options.planId + '&deptOrUser=' + options.deptOrUser, body).then(blob => {
					// if(body.mode == "all"){
						this.$message.success('正在导出，请在下载中心下载')

						// this.$message.success('导出成功，正在下载')
						let downloadElement = document.createElement('a')
						let href = window.URL.createObjectURL(blob.data) //创建下载的链接
						downloadElement.href = href
						// downloadElement.download = options.filename + '.' + options.type //下载后文件名
						// document.body.appendChild(downloadElement)
						// downloadElement.click() //点击下载
						// document.body.removeChild(downloadElement) //下载完成移除元素
						// window.URL.revokeObjectURL(href) //释放掉blob对象



				}).catch(e => {
					console.error('导出失败:' + e)
					this.$message.error('导出失败')
				})
			} else {
				await dataApi.exportFile(url, body).then(blob => {
					// if(body.mode == "all"){
						this.$message.success('正在导出，请在下载中心下载')
						// this.$message.success('导出成功，正在下载')
						let downloadElement = document.createElement('a')
						let href = window.URL.createObjectURL(blob.data) //创建下载的链接
						downloadElement.href = href
						// downloadElement.download = options.filename + '.' + options.type //下载后文件名
						// document.body.appendChild(downloadElement)
						// downloadElement.click() //点击下载
						// document.body.removeChild(downloadElement) //下载完成移除元素
						// window.URL.revokeObjectURL(href) //释放掉blob对象


				}).catch(e => {
					console.error('导出失败:' + e)
					this.$message.error('导出失败')
				})
			}
			this.loading(false)
		},
		/**
		 * 模拟预加载的生命周期 将会在vue的mounted生命周期执行
		 * 绑定基础数据 例如表格筛选项中的通用代码/下拉或者其他数据
		 * 一般会配合loadSearchOption方法来给search赋值
		 */
		async loadBaseData() {
			console.warn('页面暂无基础数据')
			return new Promise((resolve, reject) => {
				try {
					resolve({})
				} catch (e) {
					reject(e)
				}
			})
		},
		/**
		 * 筛选条件动态加载
		 * 当筛选条件有动态加载的需求时调用 一般在loadBaseData的最后调用
		 * @param data 处理数据 Object
		 * @example {platformCatId: [label:'测试',value:1]}
		 */
		loadSearchOption(data) {
			for (let item in data) {
				if (Object.prototype.hasOwnProperty.call(data, item)) {
					if (this.formConfig.items && this.formConfig.items.length) {
						this.formConfig.items.forEach(e => {
							if (e.field === item) {
								e.itemRender.options = data[item]
							}
						})
					}
				}
			}
		},
		/**
		 * 绑定基础数据
		 */
		// 预加载函数 用来加载 列表查询中的通用代码 或其他代码
		loadBeforePageEnter() {
			console.warn('页面未使用beforeRouteEnter')
		}
	},
	mounted() {
		this.loadBaseData().catch()
		//加载通用代码
		if (this.formConfig.items && this.formConfig.items.length) {
			this.formConfig.items.forEach(async e => {
				if (e.baseCode) {
					let arr = e.itemRender.options.map(item => {
						return item.value
					})
					let dataArr = await loadBaseCodeData(e.baseCode)
					dataArr.forEach(item => {
						if (!arr.includes(item.value)) {
							e.itemRender.options.push(item)
						}
					})
					// e.itemRender.options = e.itemRender.options.concat(await loadBaseCodeData(e.baseCode))
				}
				// if (e.auditStatus) {
				// 	let arr = e.itemRender.options.map(item=>{
				// 		return item.value
				// 	});
				// 	let dataArr = await loadAuditList(e.auditStatus);
				// 	dataArr.forEach(item=>{
				// 		if(!arr.includes(item.value)){
				// 			e.itemRender.options.push(item);
				// 		}
				// 	})
				// 	// e.itemRender.options = e.itemRender.options.concat(await loadAuditList(e.auditStatus))
				// }
			})
		}
	},
	activated() {
		//从其他位置跳转 需要打开页面详情页 在打开之后会替换路由
		// let keyId = localStorage.getItem('X_GRID_KEY_ID');
		// if (JSON.parse(keyId)) {
		// 	this.editRowId = this.$route.query.openDetailId;
		// 	this.editModalVisible = true;
		// 	localStorage.setItem('X_GRID_KEY_ID', null)
		// }
		// this.loadBaseData().catch();
	},
	updated() {
	}
}

export {
	GridMixin
}
